module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "五星俱乐部",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "四好运动员",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "优秀领队",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "优秀裁判员",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "优秀教练员",
      "is-link": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0485d68d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailFengcai.vue
// module id = 1356
// module chunks = 0